module.exports = __webpack_public_path__ + "img/sidebar-background-2.0a14b485.svg";